import { useQuery } from "@tanstack/react-query";
import { useTranslations } from "next-intl";
import { toast } from "sonner";

import { fetchJournals } from "@/actions/journal";
import { FormControl, FormItem, FormLabel } from "@/components/ui/form";
import { RadioGroupItem } from "@/components/ui/radio-group";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

interface IJournalsProps {
    isPending: boolean;
    value: string | undefined;
}

export const Journals = ({ value, isPending }: IJournalsProps) => {
    const t = useTranslations("expense");

    const {
        data: journals,
        error,
        isLoading,
    } = useQuery({
        queryKey: [ "journals" ],
        queryFn: fetchJournals,
    });

    if (error) {
        toast.error(t("error.fetchJournals"));
        return null;
    }

    if (isLoading) {
        return <Skeleton className="h-[68px] w-full" />;
    }

    return (
        <>
            {journals ? (
                <>
                    {journals.map(journal => (
                        <FormItem key={ journal.id }>
                            <FormControl className="hidden">
                                <RadioGroupItem value={ journal.id } />
                            </FormControl>
                            <FormLabel
                                className={ cn(
                                    "flex h-full cursor-pointer select-none flex-col border p-3 text-center font-normal",
                                    value === journal.id && "bg-muted",
                                    isPending && "pointer-events-none opacity-50",
                                ) }
                            >
                                <div className="flex h-full flex-col justify-center">
                                    {`${ journal.accountCode } ${ journal.name }`.split(" ").map((word, index) => (
                                        <span key={ index }>{word}</span>
                                    ))}
                                </div>
                            </FormLabel>
                        </FormItem>
                    ))}
                </>
            ) : null}
        </>
    );
};
